import type { PageStore } from "@/store/PageStore";
import { AppStore } from "@/store";

import { loadOrganizableNotes } from "@/actions/autoOrganizeNotes";

interface StartChatWithNotesArgs {
  noteIds: string[];
  store: AppStore;
  pageStore?: PageStore;
  overrideContext?: boolean;
}

export const startChatWithNotes = async ({
  noteIds,
  store,
  pageStore,
  overrideContext = false,
}: StartChatWithNotesArgs): Promise<void> => {
  const notes = await loadOrganizableNotes({ noteIds, store });

  if (!notes) {
    return;
  }

  const resolvedPageStore = pageStore ?? store.pageStore;
  const memItPage = resolvedPageStore?.memItPage;

  const sessionId = await store.sessions.getLatestInitialChatSession();

  if (memItPage) {
    if (overrideContext) {
      memItPage.clearAllMentions();
    }
    notes.forEach(note => memItPage.addUserNoteMention(note));
    memItPage.handleSelectSession(sessionId);
  } else {
    store.sidePanel.goToMemIt(sessionId);
  }
};
